/*
 * controllers/spaController.js
 * Spa Controller
 */

define('app/controllers/userController',[
    'app/ControllerClass',
    'app/models/userModel',
    'app/views/userView'], function (ControllerClass, UserModel, UserView) {
        return window.app.controllers.userController = $.extend({}, ControllerClass, {
            app: app,
            module: 'user',

            actions: {
                'show': ['userLogin', 'regular'],
                'create': ['userCreateCustomer', 'user'],
                'guest': ['userCreateCustomer', 'guest'],
                'addmember': ['userCreateCustomer', 'member'],
                'details': ['userCustomerProfile','normal'],
                'detailsredirectfromsummary': ['userCustomerProfile','redirect'],
                'detailssubmit': ['userCustomerProfileSubmit'],
                'createsubmit': ['userCreateCustomerSubmit', 'user'],
                'createGuestSubmit': ['userCreateCustomerSubmit', 'guest'],
                'membercreatesubmit': ['userCreateCustomerSubmit', 'member'],
                'quickmembercreatesubmit': ['userCreateCustomerSubmit', 'quickmember'],
                'quickspamembercreatesubmit': ['userCreateCustomerSubmit', 'quickspamember'],
                'quickeventmembercreatesubmit': ['userCreateCustomerSubmit', 'quickeventmember'],
                'change': ['userPasswordChange'],
                'dochange': ['userPasswordChangeSubmit'],
                'createpassword': ['createPasswordSubmit'],
                'reset': ['userPasswordReset'],
                'doreset': ['userPasswordResetSubmit'],
                'resetpassword': ['userPasswordResetV2Submit'],
                'login': ['userLogin', 'regular'],
                'confirmation': ['userLogin', 'folio'],
                'signon': ['userLogin', 'signon'],
                'authenticate': ['userLoginSubmit'],
                'authenticatefolio': ['userLoginSubmitFolio'],
                'switchfolio': ['userSwitchFolio'],
                'clearFolio': ['clearRestrictedFolio'],
                'logout': ['userLogout'],
                'removegroupmember': ['removeGroupMember'],
                'splash': ['goToSplashPageOrRedirect']
            },

            init: function () {
                console.log('initializing user controller');
                app.data.messages = app.data.messages || [];
                this.initialized = true;
            },

            userSelected: function () {
            },

            userCreateCustomer: function (type) {
                function renderCreateUserPage(contactLogTypesArr) {
                    if ((type == 'user' && app.customization.disableAccountCreation) || (type == 'member' && app.customization.disableProfileScreenCreateGroupMember)) {
                        app.dispatcher.replace('profile', '', []);
                    } else {
                        if (app.customization.login.useIntegratedLogin && type == 'user' && !app.customization.renderVueLoginApp) {
                            app.views.userView.event.fire('requestUserLogin', [app.data.lastLoginEmail, app.data.lastLoginPassword, undefined, undefined, 'regular',, contactLogTypesArr]);
                        } else {
                            if(app.customization.renderVueLoginApp) {
                                if(app.data.userLoggedIn) {
                                    app.views.userView.event.fire('renderLoginVue', ['splash'])
                                } else {
                                    type === 'guest' ? app.views.userView.event.fire('renderLoginVue', ['guest']) : app.views.userView.event.fire('renderLoginVue', ['create']);
                                }
                            } else {
                                app.views.userView.event.fire('requestCreateUser', [type]);
                            }
                        }
                    }
                }
                if(Object.keys(app.customization.visibleContactLogs).length){
                    $.when(app.models.systemModel.getData('fetchContactLogTypes', {})).done(function(r_clt){ 
                        var contactLogTypesArr = r_clt.ContactLogTypes.ContactLogType;
                        renderCreateUserPage(contactLogTypesArr)
                    }).fail(function(){
                        renderCreateUserPage()
                    })
                } else {
                    renderCreateUserPage()
                }
            },
            goToSplashPageOrRedirect: function(){
                //shows vue splash page on #/profile/splash or redirects if needs to be logged in
                if(app.customization.renderVueLoginApp) {
                    if(app.data.userLoggedIn) {
                        app.views.userView.event.fire('renderLoginVue', ['splash'])
                    } else {
                        app.views.userView.event.fire('renderLoginVue', ['login']);
                    }
                } else {
                    //regular login
                    app.dispatcher.redirect('profile','login',['next','summary']);
                }
            },
            userCustomerProfile: function (type,userId, proceedToCheckout) {
                if (app.data.userLoggedIn) {
                    var params = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    },
                        dfd = $.Deferred();
                    app.models.userModel.getData('fetchGroupMembers', params).always(function (x) {
                        dfd.resolve(x);
                    })
                    
                    $.when(
                        app.models.userModel.getData('fetchCustomerProfile', params),
                        dfd.promise()
                    )
                        .done(function (r_fcp, r_fgm) {
                            var userData = {};
                            if (userId) {
                                userData = r_fgm && r_fgm.GroupMember && $.isArray(r_fgm.GroupMember)
                                    ? _.find(r_fgm.GroupMember, function (x) { return x.CustomerId == userId })
                                    : {};
                                    //no contact logs for group members, will be extended in the future
                                    app.views.userView.event.fire('requestUserProfile', [userData, type, userId,,proceedToCheckout]);
                            } else {
                                userData = r_fcp && r_fcp.Customer && $.isArray(r_fcp.Customer)
                                    ? r_fcp.Customer[0]
                                    : {};
                                app.data.CustomerEmail = userData.EmailAddress ? userData.EmailAddress : app.data.CustomerEmail
                                //if logged in user, fetch contactlogtypes
                                if(Object.keys(app.customization.visibleContactLogs).length){
                                    $.when(app.models.systemModel.getData('fetchContactLogTypes', {})).done(function(r_clt){
                                        var contactLogTypesArr = r_clt.ContactLogTypes.ContactLogType;
                                        app.views.userView.event.fire('requestUserProfile', [userData, type, userId, contactLogTypesArr,proceedToCheckout]);
                                    }).fail(function(){
                                        app.views.userView.event.fire('requestUserProfile', [userData, type, userId,,proceedToCheckout]);
                                    })
                                } else {
                                    app.views.userView.event.fire('requestUserProfile', [userData, type, userId,,proceedToCheckout]);
                                }
                            }
                        })
                        .fail(function (r_fcp, r_fgm) {
                            app.data.messages.push({
                                type: 'alert', 'class': 'alert-error', actions: [],
                                title: app.localization.newUser.fail,
                                message: ''//r_cc.Result ? "("+r_cc.Result.Text+")" : ""
                            });
                            app.dispatcher.redirect('profile');
                        })
                } else {
                    app.dispatcher.replace('profile', '', []);
                }
            },
            userCustomerProfileSubmit: function (userEmail, userPassword, userGender, userSalutation, userFirstName, userLastName, userMainPhone, userHomePhone, userWorkPhone, userWorkExt, userOtherPhone, userMobilePhone,
                userHomeAddress1, userHomeAddress2, userHomeCity, userHomeProvince, userHomeCountry, userHomePostalCode,
                userOtherAddress1, userOtherAddress2, userOtherCity, userOtherProvince, userOtherCountry, userOtherPostalCode,
                newsletter, mailmarketing, phonemarketing, smsmarketing, language,
                userClubAddress,userClubMemberList,userClubListPhone,userClubListEmail,
                userSkiSize, userSkiBootSize,userSkierType,userCustomerType, userSnowboardSize, userSnowboardBootSize, userDinNumber, userAge, userWeight, userHeight, userDOB, customerId, proceedToCheckout) {
                if (!app.data.userLoggedIn) {
                    app.dispatcher.replace('profile', 'login', ['next', 'profile', '']);
                    return;
                }
                var phoneNumCount = 0,
                    ccParams = {
                        "Customer.CustomerId": app.data.CustomerId,
                        "Customer.CustomerGUID": app.data.CustomerGUID,
                        "Customer.Name.Salutation": userSalutation,
                        "Customer.Name.FirstName": userFirstName,
                        "Customer.Name.LastName": userLastName,
                        "Customer.EmailAddress": String(userEmail).toLowerCase(),
                        "Customer.Password": userPassword,
                        "Customer.Gender": userGender,
                        "Customer.NoEmail": +newsletter ? "N" : "Y",
                        "Customer.NoMail": +mailmarketing ? "N" : "Y",
                        "Customer.NoCall": +phonemarketing ? "N" : "Y",
                        "Customer.NoSMS": +smsmarketing ? "N" : "Y",
                        "Customer.Language": app.customization.submitLanguage[language] || ""
                    };
                if (!!customerId && app.data.CustomerId != customerId) {
                    ccParams["Customer.CustomerToChange"] = customerId || '';
                }
                ccParams["Customer.Address[1]:type=HOME.Address1"] = userHomeAddress1;
                ccParams["Customer.Address[1]:type=HOME.Address2"] = userHomeAddress2;
                ccParams["Customer.Address[1]:type=HOME.City"] = userHomeCity;
                ccParams["Customer.Address[1]:type=HOME.StateProv"] = userHomeProvince;
                ccParams["Customer.Address[1]:type=HOME.Country"] = userHomeCountry;
                ccParams["Customer.Address[1]:type=HOME.PostCode"] = userHomePostalCode;
                ccParams["Customer.Address[2]:type=OTHER.Address1"] = userOtherAddress1;
                ccParams["Customer.Address[2]:type=OTHER.Address2"] = userOtherAddress2;
                ccParams["Customer.Address[2]:type=OTHER.City"] = userOtherCity;
                ccParams["Customer.Address[2]:type=OTHER.StateProv"] = userOtherProvince;
                ccParams["Customer.Address[2]:type=OTHER.Country"] = userOtherCountry;
                ccParams["Customer.Address[2]:type=OTHER.PostCode"] = userOtherPostalCode;
                if (userHomePhone) {
                    ccParams["Customer.Phone[" + phoneNumCount + "]:" + (userMainPhone == "H" ? "primary=true;" : "") + "type=HOME.PhoneNumber"] = userHomePhone;
                    phoneNumCount++;
                }
                if (userWorkPhone) {
                    ccParams["Customer.Phone[" + phoneNumCount + "]:" + (userMainPhone == "W" ? "primary=true;" : "") + "type=WORK.PhoneData.PhoneNumber"] = userWorkPhone;
                    if (userWorkExt) {
                        ccParams["Customer.Phone[" + phoneNumCount + "]:" + (userMainPhone == "W" ? "primary=true;" : "") + "type=WORK.PhoneData.Extension"] = userWorkExt;
                    }// else {
                    //ccParams["Customer.Phone["+phoneNumCount+"]:"+(userMainPhone=="W"?"primary=true;":"")+"type=WORK.PhoneNumber"] = userWorkPhone;
                    //}
                    phoneNumCount++;
                }
                if (userOtherPhone) {
                    ccParams["Customer.Phone[" + phoneNumCount + "]:" + (userMainPhone == "O" ? "primary=true;" : "") + "type=OTHER.PhoneNumber"] = userOtherPhone;
                    phoneNumCount++;
                }
                if (userMobilePhone) {
                    ccParams["Customer.Phone[" + phoneNumCount + "]:" + (userMainPhone == "M" ? "primary=true;" : "") + "type=MOBILE.PhoneNumber"] = userMobilePhone;
                    phoneNumCount++;
                }
                if (app.customization.features.skiBooking) {
                    ccParams["Customer.SkiSettings.SkiSize"] = userSkiSize || "";
                    ccParams["Customer.SkiSettings.SkiBootSize"] = userSkiBootSize || "";
                    ccParams["Customer.SkiSettings.SkierType"] = userSkierType || "";
                    ccParams["Customer.SkiSettings.SkiCustomerType"] = userCustomerType || "";
                    ccParams["Customer.SkiSettings.SnowboardSize"] = userSnowboardSize || "";
                    ccParams["Customer.SkiSettings.SnowboardBootSize"] = userSnowboardBootSize || "";
                    ccParams["Customer.SkiSettings.DinNumber"] = userDinNumber || "";
                    ccParams["Customer.SkiSettings.Age"] = userAge || "";
                    ccParams["Customer.SkiSettings.Weight"] = userWeight || "";
                    ccParams["Customer.SkiSettings.Height"] = userHeight || "";
                }
               // if (app.customization.features.clubBooking) {
                    ccParams["Customer.ClubSettings.ListAddress"] = userClubAddress || "";
                    ccParams["Customer.ClubSettings.MemberList"] = +userClubMemberList ? 'Y' : 'N';
                    ccParams["Customer.ClubSettings.ListPhone"] = userClubListPhone || "";
                    ccParams["Customer.ClubSettings.ListEmail"] = +userClubListEmail  ? 'Y': 'N';
                  
               // }
               if(Object.keys(app.customization.visibleContactLogs).length) {
                var updatedContactLogs = app.data.updatedContactLogs || [];
                updatedContactLogs.forEach(function(contactLog, index){
                    var id = contactLog.id || '';
                    var name = contactLog.name;
                    var value = contactLog.value;
                    var shiftedIndex = index + 1;
                    if(id || name) {
                        var structuredContactLogsParam = "Customer.ContactLogs.ContactLog["+ shiftedIndex +"]:id=" + id + ";name=" + name;
                        ccParams[structuredContactLogsParam] =  value.replace(/(%0A)/gm, '\n').replace(/(%20)/gm, ' '); 
                    }
                })
                //clear updated contact logs from localstorage after parsing everything
                app.datal(updatedContactLogs, []);
               }
                if (userDOB) {
                    ccParams["Customer.DateOfBirth"] = userDOB;
                }

                $.when(app.models.systemModel.getData('updateCustomerProfile', ccParams))
                    .done(function (r_cc) {
                        app.data.messages.push({
                            type: 'alert', class: '', actions: [],
                            title: app.localization.newUser.successUpdate,
                            message: ""
                        });
                    if(app.customization.skiBooking.guestProfileUpdateOnCheckout && window.location.href.indexOf('detailsredirectfromsummary')> -1)  {  
                        app.commonViewHelper.handleSkiLoopPerUserProfile(customerId,true)
                    }
                    else if (app.data.loginNextURL) {
                            app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                    } else {
                        if(proceedToCheckout){
                            //clear all messages
                            app.data.messages = [];
                            app.data.messages.push({
                                type: 'alert', class: '', actions: [],
                                title: app.localization.newUser.successUpdate,
                                message: ""
                            });
                            app.dispatcher.dispatch('summary','checkout')
                        } else {
                            app.dispatcher.redirect('profile');
                        }
                    }
                    app.data.loginNextURL = undefined;
                    })
                    .fail(function (r_cc) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.newUser.errorUpdate,
                            message: r_cc.Result ? r_cc.Result.Text : ""
                        });
                        if (app.data.loginNextURL) {
                            app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                        } else {
                            app.dispatcher.redirect('profile');
                        }
                        app.data.loginNextURL = undefined;
                    })

            },


            userCreateCustomerSubmit: function (type, userEmail, userPassword, userGender, userSalutation, userFirstName, userLastName,
                userMainPhone, userHomePhone, userWorkPhone, userWorkExt, userOtherPhone, userMobilePhone,
                userHomeAddress1, userHomeAddress2, userHomeCity, userHomeProvince, userHomeCountry, userHomePostalCode,
                userOtherAddress1, userOtherAddress2, userOtherCity, userOtherProvince, userOtherCountry, userOtherPostalCode,
                newsletter, mailmarketing, phonemarketing, smsmarketing, language, userClubAddress,userClubMemberList,userClubListPhone,userClubListEmail,
                userSkiSize, userSkiBootSize, userSkierType,userCustomerType,userSnowboardSize, userSnowboardBootSize, userDinNumber, userAge, userWeight, userHeight, userDOB, stringifiedContactLogs) {

                if (app.customization.disableProfileScreenCreateGroupMember && type == 'member') {
                    app.dispatcher.replace('profile', '', []);
                    return;
                }
                if (app.customization.skiBooking.disallowQuickAddGroupMember && type == 'quickmember') {
                    app.dispatcher.replace('profile', '', []);
                    return;
                }
                if (app.customization.spaBooking.disallowQuickAddGroupMember && (type == 'quickspamember' || type == 'quickeventmember')) {
                    app.dispatcher.replace('profile', '', []);
                    return;
                }

                var dfd = false;
                if (type == 'dfd') {
                    dfd = $.Deferred();
                    type = 'user';
                }

                var quickadd = false,
                    quickaddspa = 0;
                if (type == 'quickmember' || type == 'quickspamember' || type == 'quickeventmember') {
                    quickadd = true;
                    if (type == 'quickspamember') {
                        quickaddspa = 2;
                    }
                    if (type == 'quickeventmember') {
                        quickaddspa = 1;
                    }
                    type = 'member';
                }
                if (app.customization.disableAccountCreation && (type == "user" || type == "guest")) {
                    app.dispatcher.replace('profile', '', []);
                    return;
                }
                if (type == 'member' && !app.data.userLoggedIn) {
                    app.dispatcher.replace('profile', 'login', ['next', 'profile', 'addmember']);
                    return;
                }
                var paramPrefix = 'NewCustomer.',
                    phoneNumCount = 0,
                    ccParams = {};
                if (type == 'member') {
                    ccParams["CustomerId"] = app.data.CustomerId;
                    ccParams["CustomerGUID"] = app.data.CustomerGUID;
                    paramPrefix = 'NewGroupMember.'
                }

                ccParams[paramPrefix + "Name.Salutation"] = userSalutation,
                    ccParams[paramPrefix + "Name.FirstName"] = userFirstName,
                    ccParams[paramPrefix + "Name.LastName"] = userLastName,
                    ccParams[paramPrefix + "EmailAddress"] = String(userEmail).toLowerCase(),
                    ccParams[paramPrefix + "Password"] = userPassword,
                    ccParams[paramPrefix + "Gender"] = userGender,
                    ccParams[paramPrefix + "NoEmail"] = +newsletter ? "N" : "Y",
                    ccParams[paramPrefix + "NoMail"] = +mailmarketing ? "N" : "Y",
                    ccParams[paramPrefix + "NoCall"] = +phonemarketing ? "N" : "Y",
                    ccParams[paramPrefix + "NoSMS"] = +smsmarketing ? "N" : "Y",
                    ccParams[paramPrefix + "Language"] = { "en-us": "English", "es-sp": "Spanish", "fr-ca": "French" }[language] || ""

                ccParams[paramPrefix + "Address[1]:type=HOME.Address1"] = userHomeAddress1;
                ccParams[paramPrefix + "Address[1]:type=HOME.Address2"] = userHomeAddress2;
                ccParams[paramPrefix + "Address[1]:type=HOME.City"] = userHomeCity;
                ccParams[paramPrefix + "Address[1]:type=HOME.StateProv"] = userHomeProvince;
                ccParams[paramPrefix + "Address[1]:type=HOME.Country"] = userHomeCountry;
                ccParams[paramPrefix + "Address[1]:type=HOME.PostCode"] = userHomePostalCode;
                ccParams[paramPrefix + "Address[2]:type=OTHER.Address1"] = userOtherAddress1;
                ccParams[paramPrefix + "Address[2]:type=OTHER.Address2"] = userOtherAddress2;
                ccParams[paramPrefix + "Address[2]:type=OTHER.City"] = userOtherCity;
                ccParams[paramPrefix + "Address[2]:type=OTHER.StateProv"] = userOtherProvince;
                ccParams[paramPrefix + "Address[2]:type=OTHER.Country"] = userOtherCountry;
                ccParams[paramPrefix + "Address[2]:type=OTHER.PostCode"] = userOtherPostalCode;

                if (userHomePhone) {
                    ccParams[paramPrefix + "Phone[" + phoneNumCount + "]:" + (userMainPhone == "H" ? "primary=true;" : "") + "type=HOME.PhoneNumber"] = userHomePhone;
                    phoneNumCount++;
                }
                if (userWorkPhone) {
                    ccParams[paramPrefix + "Phone[" + phoneNumCount + "]:" + (userMainPhone == "W" ? "primary=true;" : "") + "type=WORK.PhoneData.PhoneNumber"] = userWorkPhone;
                    if (userWorkExt) {
                        ccParams[paramPrefix + "Phone[" + phoneNumCount + "]:" + (userMainPhone == "W" ? "primary=true;" : "") + "type=WORK.PhoneData.Extension"] = userWorkExt;
                    }// else {
                    //     ccParams[paramPrefix + "Phone["+phoneNumCount+"]:"+(userMainPhone=="W"?"primary=true;":"")+"type=WORK.PhoneNumber"] = userWorkPhone;
                    // }
                    phoneNumCount++;
                }
                if (userOtherPhone) {
                    ccParams[paramPrefix + "Phone[" + phoneNumCount + "]:" + (userMainPhone == "O" ? "primary=true;" : "") + "type=OTHER.PhoneNumber"] = userOtherPhone;
                    phoneNumCount++;
                }
                if (userMobilePhone) {
                    ccParams[paramPrefix + "Phone[" + phoneNumCount + "]:" + (userMainPhone == "M" ? "primary=true;" : "") + "type=MOBILE.PhoneNumber"] = userMobilePhone;
                    phoneNumCount++;
                }
                if (app.customization.features.skiBooking) {
                    ccParams[paramPrefix + "SkiSettings.SkiSize"] = userSkiSize;
                    ccParams[paramPrefix + "SkiSettings.SkiBootSize"] = userSkiBootSize;
                    ccParams[paramPrefix + "SkiSettings.SkierType"] = userSkierType;
                    ccParams[paramPrefix + "SkiSettings.SkiCustomerType"] = userCustomerType;
                    ccParams[paramPrefix + "SkiSettings.SnowboardSize"] = userSnowboardSize;
                    ccParams[paramPrefix + "SkiSettings.SnowboardBootSize"] = userSnowboardBootSize;
                    ccParams[paramPrefix + "SkiSettings.DinNumber"] = userDinNumber;
                    ccParams[paramPrefix + "SkiSettings.Age"] = userAge;
                    ccParams[paramPrefix + "SkiSettings.Weight"] = userWeight;
                    ccParams[paramPrefix + "SkiSettings.Height"] = userHeight;
                }
                if(Object.keys(app.customization.visibleContactLogs).length && stringifiedContactLogs) {
                    var parsedContactLog = JSON.parse(stringifiedContactLogs) || [];
                    parsedContactLog.forEach(function(contactLog, index){
                        var name = contactLog.name;
                        var value = contactLog.value;
                        var shiftedIndex = index + 1;
                        if(name) {
                            var structuredContactLogsParam = "ContactLogs.ContactLog["+ shiftedIndex +"]:name=" + name;
                            ccParams[structuredContactLogsParam] =  value; 
                        }
                    })
                }
                if (userDOB) {
                    ccParams[paramPrefix + "DateOfBirth"] = userDOB;
                }

                $.when(app.models.systemModel.getData((type == 'user' || type == 'guest') ? 'createCustomer' : 'createGroupMember', ccParams))
                    .done(function (r_cc) {
                        /*app.data.messages.push({ type:'alert', class:'', actions:[],
                            title:app.localization.newUser.success,
                            message:""
                        });*/
                        if (type == 'user' || type == 'guest') {
                            app.datac('userLoggedIn', true);
                            app.datac('CustomerId', r_cc.CustomerId);
                            app.datac('CustomerGUID', r_cc.CustomerGUID);
                            app.datac('FirstName', userFirstName);
                            app.datac('LastName', userLastName);
                            app.datac('CustomerEmail', userEmail);
                            if(type == 'guest') {
                                app.datac('guestUser', true);
                            }
                            $.when(
                                app.models.systemModel.getData('updateSession', { CustomerId: r_cc.CustomerId, CustomerGUID: r_cc.CustomerGUID }),
                                app.customization.dynamicRestrictions && app.commonViewHelper.memberVipLevelsHelper()  // Adding memberVipHelper Func before evalCriteria runs if dynamicRestrictions set
                            )
                                .done(function (r) {
                                    // If Dynamic Restrictions Exist then call evalCriteria when use logging in
                                    if(app.customization.dynamicRestrictions){
                                        app.commonViewHelper.evalCriteria();
                                        app.commonViewHelper.enableModuleHelper();
                                    }
                                    app.data.messages.push({
                                        type: 'alert', 'class': '', actions: [],
                                        title: app.localization.newUser.success,
                                        message: userPassword == app.data.newpassword ? app.localization.newUser.successRandomPassword(app.data.newpassword) : '' // r.Result ? "("+r.Result.Text+")" : ""
                                    });
                                 //If guestProfileUpdateOnCheckout is true and user added ski/class that is rental then CustomerId(app.data.CustomerId) that is used to book is different when user logs in. So it is importantto replace old Customer Ids inside  GuestwithSkiInCart  -START-
                                if(app.customization.skiBooking.guestProfileUpdateOnCheckout && app.data.GuestsWithSkiInCart && !_.isEmpty(app.data.GuestsWithSkiInCart)){  
                                    var customerobjectWithNewId = {}
                                    _.each(app.data.GuestsWithSkiInCart,function(folio,customerId){
                                        customerobjectWithNewId[app.data.CustomerId] = folio
                                        app.datal('GuestsWithSkiInCart',customerobjectWithNewId)
                                    })
                                 }
                                    if (r && r.ConflictingSpaBookingRemoved == 'Y') {
                                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                            title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                            message:app.localization.general.conflictingSpaBookingRemoved
                                        });
                                    }
                                    if (dfd) {
                                        dfd.resolve(r);
                                        return dfd
                                    }
                                    if (app.data.loginNextURL) {
                                        //change loginNextURL to pass it to checkout to prevent forcing required fields
                                        if(app.data.loginNextURL.indexOf('checkout') !== -1){
                                            app.data.loginNextURL[2] = ['guest'];
                                        }
                                
                                        app.dispatcher.redirect.apply(this, app.data.loginNextURL);
                                        
                                    } else {
                                        if(app.customization.renderVueLoginApp) {
                                            app.views.userView.event.fire('renderLoginVue', ['splash']);
                                        } else {
                                            app.dispatcher.redirect('summary');
                                        }
                                    }
                                    app.data.loginNextURL = undefined;
                                    
                                })
                                .fail(function (r) {
                                    app.data.messages.push({
                                        type: 'alert', 'class': 'alert-error', actions: [],
                                        title: app.localization.newUser.updateSessionFailed,
                                        message: '' //r.Result ? "("+r.Result.Text+")" : ""
                                    });
                                    app.dispatcher.redirect('profile');
                                })
                        } else {
                            app.data.messages.push({
                                type: 'alert', 'class': '', actions: [],
                                title: app.localization.newUser.successMember,
                                message: '' //r.Result ? "("+r.Result.Text+")" : ""
                            });
                            if (app.data.loginNextURL) {
                                if ($.isArray(app.data.loginNextURL) && $.isArray(app.data.loginNextURL[2])) {
                                    switch (app.data.loginNextURL[1]) {
                                        case "eventcalendar": quickaddspa = 1; break;
                                        case "service": quickaddspa = 2; break;
                                    }
                                    app.data.loginNextURL[2][quickaddspa + 2] = r_cc.NewGroupMemberCustomerId;
                                }
                                app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                            } else {
                                app.dispatcher.redirect('profile');
                            }
                            app.data.loginNextURL = undefined;
                        }
                    })
                    .fail(function (r_cc) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.newUser.fail,
                            message: r_cc.Result ? r_cc.Result.Text : ""
                        });
                        if (dfd) {
                            dfd.reject(r_cc);
                            return dfd
                        }
                        if(window.location.hash == '#/profile'){
                            app.dispatcher.dispatch('profile', 'login', []);
                        } else {
                            app.dispatcher.redirect('profile');
                        }
                    })
                return dfd;
            },


            userPasswordChange: function (eventName, oldPassword, conflictsRemoved) {
                if (app.data.userLoggedIn) {
                    app.views.userView.event.fire('requestChangePassword', [eventName, oldPassword, conflictsRemoved]);
                } else {
                    app.dispatcher.replace('profile', '', []);
                }
            },

            userPasswordReset: function (emailaddress) {
                if (app.customization.disablePasswordReset) {
                    app.dispatcher.replace('profile', '', []);
                    return;
                }
                app.views.userView.event.fire('requestResetPassword', [emailaddress]);
            },
            userPasswordResetV2Submit: function (passwordGUID, emailaddress) {
                //First call of resetPasswordCustomer without the password - check guid validity
                $.when(app.models.userModel.getData('resetPasswordCustomer', { EmailAddress: emailaddress.toLowerCase(), PasswordGUID: passwordGUID }))
                    .done(function (r_pc) {
                        // redirection to reset password from
                        app.views.userView.event.fire('requestResetPasswordChange', [emailaddress, passwordGUID]);
                    })
                    .fail(function (r_pc) {
                        // Invalid guid or faliure
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: r_pc.Result.Text || app.localization.general.err.defaultErr,
                            message: ""
                        });
                        app.dispatcher.redirect('profile');
                    });
            },
            userPasswordResetSubmit: function (emailaddress, eventName) {
                if (app.customization.disablePasswordReset) {
                    app.dispatcher.replace('profile', '', []);
                    return;
                }
                if (typeof emailaddress != 'string') {
                    app.data.messages.push({
                        type: 'alert', 'class': 'alert-error', actions: [],
                        title: app.localization.general.err.defaultErr,
                        message: ""
                    });
                    app.dispatcher.redirect('profile');
                }
                $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: emailaddress.toLowerCase() }))
                    .done(function (r_ce) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.general.err.emailErrNotExist,
                            message: ""
                        });
                        app.dispatcher.replace('profile');
                    })
                    .fail(function (r_ce) {
                        $.when(app.models.userModel.getData('resetPasswordCustomer', { EmailAddress: emailaddress.toLowerCase() }))
                            .done(function (r_pc) {
                                app.data.messages.push({
                                    type: 'alert', 'class': '', actions: [],
                                    title: app.localization.general.login.passwordReset.newPasswordEmailConfirmation,
                                    message: ""
                                });
                                if (eventName) {
                                    $('#progressIndicator').modal('hide');
                                    app.views.userView.event.fire(eventName, [true]);
                                    return
                                }
                                app.dispatcher.redirect('profile');
                            })
                            .fail(function (r_pc) {
                                app.data.messages.push({
                                    type: 'alert', 'class': 'alert-error', actions: [],
                                    title: app.localization.general.err.defaultErr,
                                    message: ""
                                });
                                if (eventName) {
                                    app.views.userView.event.fire(eventName, [false, r_pc]);
                                    return
                                }
                                app.dispatcher.redirect('profile');
                            });

                    });
            },

            userPasswordChangeSubmit: function (emailaddress, oldpassword, newpassword, eventName, conflictsRemoved) {
                if (typeof emailaddress != 'string') {
                    app.data.messages.push({
                        type: 'alert', 'class': 'alert-error', actions: [],
                        title: app.localization.general.err.defaultErr,
                        message: ""
                    });
                    app.dispatcher.redirect('profile');
                }
                $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: emailaddress.toLowerCase() }))
                    .done(function (r_ce) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.general.err.emailErrNotExist,
                            message: ""
                        });
                    })
                    .fail(function (r_ce) {
                        $.when(app.models.userModel.getData('changePasswordCustomer', { EmailAddress: emailaddress.toLowerCase(), PasswordOld: oldpassword, PasswordNew: newpassword }))
                            .done(function (r_pc) {
                                $('#progressIndicator').modal('hide')
                                app.data.messages.push({
                                    type: 'alert', 'class': '', actions: [],
                                    title: app.localization.general.login.changePassword.updateSuccess,
                                    message: ""
                                });
                                if (conflictsRemoved) {
                                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                        title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                        message:app.localization.general.conflictingSpaBookingRemoved
                                    });
                                    app.dispatcher.redirect('profile');
                                    return;
                                }
                                if (eventName) {
                                    $('#userChangePasswordForm').attr('id', 'userCreateUserForm');
                                    $('#userCreateUserForm > div.userChangePasswordForm').hide()
                                    app.views.userView.event.fire(eventName, [true, 'redirect']);
                                    return
                                }
                                if (app.data.loginNextURL) {
                                    app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                } else {
                                    app.dispatcher.redirect('profile');
                                }
                                app.data.loginNextURL = undefined;

                            })
                            .fail(function (r_pc) {
                                $('#progressIndicator').modal('hide')
                                app.data.messages.push({
                                    type: 'alert', 'class': 'alert-error', actions: [],
                                    title: app.localization.general.login.changePassword.err.resetFailed,
                                    message: ""
                                });
                                if (eventName) {
                                    app.views.userView.event.fire(eventName, [false]);
                                    return
                                }
                                app.dispatcher.redirect('profile');
                            });
                    });
            },

            createPasswordSubmit: function (emailaddress, oldpassword, newpassword, eventName, conflictsRemoved) {
                if (typeof emailaddress != 'string') {
                    app.data.messages.push({
                        type: 'alert', 'class': 'alert-error', actions: [],
                        title: app.localization.general.err.defaultErr,
                        message: ""
                    });
                    app.dispatcher.redirect('profile');
                }
                $.when(app.models.userModel.getData('checkCustomerEmail', { EmailAddress: emailaddress.toLowerCase() }))
                    .done(function (r_ce) {
                        app.data.messages.push({
                            type: 'alert', 'class': 'alert-error', actions: [],
                            title: app.localization.general.err.emailErrNotExist,
                            message: ""
                        });
                    })
                    .fail(function (r_ce) {
                        $.when(app.models.userModel.getData('changePasswordCustomer', { EmailAddress: emailaddress.toLowerCase(), PasswordOld: '', PasswordNew: newpassword }))
                            .done(function (r_pc) {
                                app.data.messages.push({
                                    type: 'alert', 'class': '', actions: [],
                                    title: app.localization.general.login.changePassword.createSuccess,
                                    message: ""
                                });
                                app.datac('RestrictedFolio', null);
                                delete app.data.folioLoginHasPassword;
                                app.controllers.initController.initGuestItinerary();
                                if (conflictsRemoved) {
                                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                        title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                        message:app.localization.general.conflictingSpaBookingRemoved
                                    });
                                    app.dispatcher.redirect('profile');
                                    return;
                                }
                                if (eventName) {
                                    $('#userChangePasswordForm').attr('id', 'userCreateUserForm');
                                    $('#userCreateUserForm > div.userChangePasswordForm').hide()
                                    app.views.userView.event.fire(eventName, [true, 'redirect']);
                                    return
                                }
                                if (app.data.loginNextURL) {
                                    app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                } else {
                                    app.dispatcher.redirect('profile');
                                }
                                app.data.loginNextURL = undefined;

                            })
                            .fail(function (r_pc) {
                                app.data.messages.push({
                                    type: 'alert', 'class': 'alert-error', actions: [],
                                    title: app.localization.general.login.changePassword.err.resetFailed,
                                    message: ""
                                });
                                if (eventName) {
                                    app.views.userView.event.fire(eventName, [false]);
                                    return
                                }
                                app.dispatcher.redirect('profile');
                            });
                    });
            },

            userLogin: function () {
                var mode = [].shift.call(arguments);
                app.dispatcher.updateURL('profile', 'login')
                var hasNextURL = false;
                if (arguments[0] == "next") {
                    hasNextURL = true;
                    [].shift.call(arguments);
                    app.data.loginNextURL = [];
                    var module, action;
                    (module = [].shift.call(arguments)) && app.data.loginNextURL.push(module);
                    (action = [].shift.call(arguments)) && app.data.loginNextURL.push(action);
                    arguments && app.data.loginNextURL.push($.makeArray(arguments));
                } else if(arguments[0] == 'partial-payment') {
                    hasNextURL =true
                }
                if (app.data.userLoggedIn) {
                    var params = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    }
                    var dfd = $.Deferred();

                    app.models.userModel.getData('fetchGroupMembers', params).always(function (x) {
                        dfd.resolve(x);
                    })
                   
                    $.when(
                        app.models.userModel.getData('fetchCustomerProfile', params),
                        dfd.promise(),
                        Object.keys(app.customization.visibleContactLogs).length && app.models.systemModel.getData('fetchContactLogTypes', {})
                    ).done(function (r_fcp, r_fgm, r_clt) {
                            var contactLogTypesArr = r_clt ? r_clt.ContactLogTypes.ContactLogType : [];
                            var userData = r_fcp && r_fcp.Customer && $.isArray(r_fcp.Customer) ? r_fcp.Customer[0] : {};
                            app.data.CustomerEmail = userData.EmailAddress ? userData.EmailAddress : app.data.CustomerEmail
                            if (hasNextURL) {
                                app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                            } else {
                                // redirect to guest profile
                                if(app.customization.renderVueLoginApp) {
                                    if(app.data.userLoggedIn){
                                        app.views.userView.event.fire('requestUserLogin', [app.data.CustomerEmail, app.data.lastLoginPassword, r_fcp, r_fgm, mode,, contactLogTypesArr]);
                                    } else {
                                        app.views.userView.event.fire('renderLoginVue', ['login']);
                                    }
                                } else {
                                    app.views.userView.event.fire('requestUserLogin', [app.data.CustomerEmail, app.data.lastLoginPassword, r_fcp, r_fgm, mode,, contactLogTypesArr]);
                                }
                            }
                            app.data.loginNextURL = undefined;
                        })
                        .fail(function (r_fcp, r_fgm) {
                            app.data.messages.push({
                                type: 'alert', 'class': 'alert-error', actions: [],
                                title: app.localization.newUser.fail,
                                message: ''//r_cc.Result ? "("+r_cc.Result.Text+")" : ""
                            });
                            app.dispatcher.redirect('profile');
                        })
                } else {
                    if(app.customization.renderVueLoginApp) {
                        app.views.userView.event.fire('renderLoginVue', ['login']);
                    } else {
                        if(Object.keys(app.customization.visibleContactLogs).length){
                            $.when(app.models.systemModel.getData('fetchContactLogTypes', {})).done(function(r_clt){
                                var contactLogTypesArr = r_clt.ContactLogTypes.ContactLogType;
                                app.views.userView.event.fire('requestUserLogin', [app.data.lastLoginEmail, app.data.lastLoginPassword, undefined, undefined, mode, arguments,contactLogTypesArr]);
                            })
                        } else {
                            app.views.userView.event.fire('requestUserLogin', [app.data.lastLoginEmail, app.data.lastLoginPassword, undefined, undefined, mode, arguments]);
                        }
                    }
                }
            },

            userLoginSubmitFolio: function (folioid, lastname, eventName, emailaddress) {
                var r_l
                app.models.userModel.getData('authCustomer', { FolioId: folioid, LastName: lastname.toUpperCase(), EmailAddress: emailaddress }
                )
                .then(function (response) {
                        r_l = response;
                            app.data.messages.push({ type:'alert', 'class':'alert-success', actions: [],
                                title:app.localization.general.login.loginSuccess,
                                message:''
                            });
                        return app.models.userModel.getData('fetchCustomerProfile', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID })
                    }, function(){
                        //login failure
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.general.login.invalidFolio,
                            message:''
                        });
                        app.dispatcher.dispatch('profile', 'confirmation');
                    })
                    .done(function (r_fcp) {
                        app.datac('userLoggedIn', true);
                        app.datac('CustomerId', r_l.CustomerId);
                        app.datac('CustomerGUID', r_l.CustomerGUID);
                        app.datac('FirstName', r_l.FirstName);
                        app.datac('LastName', r_l.LastName);
                        app.datac('folioLoginHasPassword', r_l.HasPassword);
                        app.datac('RestrictedFolio', folioid);
                        app.datac('RestrictedLogin', true);
                        app.datac('CustomerEmail', r_fcp.Customer[0].EmailAddress.toLowerCase());
                        if (!app.data.SessionId) {
                            window.location.reload(false);
                            return
                        }
                        $.when(
                            app.models.systemModel.getData('updateSession', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID }),
                            app.controllers.initController.initGuestItinerary(),
                            app.customization.dynamicRestrictions && app.commonViewHelper.memberVipLevelsHelper()  // Adding memberVipHelper Func before evalCriteria runs if dynamicRestrictions set
                        )
                            .done(function (r_us) {
                                // If Dynamic Restrictions Exist then call evalCriteria when use logging in
                                if(app.customization.dynamicRestrictions){
                                    app.commonViewHelper.evalCriteria();
                                    app.commonViewHelper.enableModuleHelper();
                                }
                                if (r_us && r_us.ConflictingSpaBookingRemoved == 'Y') {
                                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                        title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                        message:app.localization.general.conflictingSpaBookingRemoved
                                    });
                                }
                                var vueRef = null;
                                if(app.data.vueAppRef){
                                    vueRef = app.data.vueAppRef;
                                }else if(app.data.modeSelectorVueAppRef) {
                                    vueRef = app.data.modeSelectorVueAppRef;
                                }
                                else if(app.data.optionalClassVueAppRef) vueRef = app.data.optionalClassVueAppRef;
                                if(vueRef) vueRef.$store.commit('setActiveStep',0);
                                if(eventName){
                                    app.dispatcher.replace('summary', 'show', []);
                                    app.views.userView.event.fire(eventName, [true]);
                                    return
                                }
                                else if(app.data.loginNextURL) {
                                    app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                    return;
                                }
                              
                            })
                            .fail(function (r_us, r_fb) {
                                window.location.reload(false);
                            })
                    })
                    .fail(function (r_l) {
                        // if (eventName) {
                        //     app.views.userView.event.fire(eventName, [false,r_l]);
                        //     return
                        // }
                        // app.dispatcher.dispatch('profile', 'login', ['fail']);

                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.general.login.invalidFolio,
                            message:''
                        });
                    app.dispatcher.dispatch('profile', 'confirmation');
                    })
            },

            userSwitchFolio: function (actualfolioid, userenteredfolioid, eventName) {
                var found = (!app.customization.login.strictMode || actualfolioid == userenteredfolioid) && _.any(app.data.pmsBookings, function (e) {
                    return e.PMSFolioId == actualfolioid
                })
                if (found) {
                    app.datac('RestrictedFolio', actualfolioid);
                    app.controllers.initController.initGuestItinerary().done(function () {
                        app.dispatcher.replace('summary', 'show', []);
                    })
                    app.data.messages.push({
                        type: 'alert', class: '', actions: [],
                        title: app.localization.bookingSummary.folioSwitchSuccess,
                        message: ""
                    });
                } else {
                    app.data.messages.push({
                        type: 'alert', 'class': 'alert-error', actions: [],
                        title: app.localization.bookingSummary.folioErrNotExist,
                        message: ""
                    });
                    $('input.switchFolioId'); app.dispatcher.replace('summary', 'show', []);
                }
            },

            clearRestrictedFolio: function () {
                app.datac('RestrictedFolio', '');
                app.datac('RestrictedLogin', false);
                app.controllers.initController.initGuestItinerary().done(function () {
                    app.dispatcher.replace('summary', 'show', []);
                })
                app.data.messages.push({
                    type: 'alert', class: '', actions: [],
                    title: app.localization.bookingSummary.resctrictionDisabled,
                    message: ""
                });
            },

            userLoginSubmit: function (email, password, eventName,urlParameter,oAuthLogin, mode) {
                app.data.lastLoginEmail = email;
                app.data.lastLoginPassword = password;
                $('#progressIndicator').modal('show');
                $.when(
                   !oAuthLogin ? !!email && typeof email == 'string' && /^[^@"(),:;<&>\/\[\\\]|`][^@"(),:;<>\/\[\\\]|`]*@[a-z0-9-]+(\.?[a-z0-9-])*\.[a-z0-9]{2,}$/i.test(email) &&
                    !!password && typeof password == 'string' && password.length > 7 &&
                    app.models.userModel.getData('authCustomer', { EmailAddress: email.toLowerCase(), Password: password })
                    || (function () { var d = $.Deferred(); d.reject(false); return d })()
                     :oAuthLogin )
                    .done(function (r_l) {
                        // if oAuthLogin then do not add login message since it has its own message
                        //login success message
                        if(!oAuthLogin){
                            app.data.messages.push({ type:'alert', 'class':'alert-success', actions: [],
                                title:app.localization.general.login.loginSuccess,
                                message:''
                            });
                        }

                        // process r_l.customerId, etc here
                        app.datac('userLoggedIn', true);
                        app.datac('CustomerId', r_l.CustomerId);
                        app.datac('CustomerGUID', r_l.CustomerGUID);
                        app.datac('FirstName', r_l.FirstName);
                        app.datac('LastName', r_l.LastName);
                        app.datac('folioLoginHasPassword', null);
                        app.datac('RestrictedFolio', null);
                        app.datac('RestrictedLogin', null);
                        app.datac('CustomerEmail', email.toLowerCase());
                        if (!app.data.SessionId) {
                            window.location.reload(false);
                            return
                        }
                        if(app.data.vueLoginAppRef) {
                            var loginStore = app.data.vueLoginAppRef.$store
                            loginStore.commit('setFirstName',{firstName: r_l.FirstName}); //if you previously selected a service, before logging in, then upon return to that page again, it 
                        }
                 
                        $.when(
                            app.models.systemModel.getData('updateSession', { CustomerId: r_l.CustomerId, CustomerGUID: r_l.CustomerGUID }),
                            app.controllers.initController.initGuestItinerary(),
                            app.customization.dynamicRestrictions && app.commonViewHelper.memberVipLevelsHelper()  // Adding memberVipHelper Func before evalCriteria runs if dynamicRestrictions set
                        )
                            .done(function (r_us) {
                                var store = null;
                                if(app.data.vueAppRef) {
                                    store = app.data.vueAppRef.$store;
                                    if(window.location.href.indexOf('package') > -1){
                                        store.commit('setActiveService',''); //if you previously selected a service, before logging in, then upon return to that page again, it was auto selecting that service again
                                    }
                                }
                                else if(app.data.modeSelectorVueAppRef) store = app.data.modeSelectorVueAppRef.$store;
                                else if(app.data.optionalClassVueAppRef) store = app.data.optionalClassVueAppRef.$store;
                               
                                // else if(app.data.vueLoginAppRef) store = app.data.vueLoginAppRef.$store;
                                if(store) {
                                    store.commit('setLoggedInUser',{userId: r_l.CustomerId});
                                   
                                }
                                // If Dynamic Restrictions Exist then call evalCriteria when use logging in
                                if(app.customization.dynamicRestrictions){
                                    app.commonViewHelper.evalCriteria();
                                    app.commonViewHelper.enableModuleHelper();
                                }

                                //If guestProfileUpdateOnCheckout is true and user added ski/class that is rental than CustomerId(app.data.CustomerId)  is different when user logs in. So it is important to replace old Customer Ids inside  GuestwithSkiInCart  -START-
                                if(app.customization.skiBooking.guestProfileUpdateOnCheckout && app.data.GuestsWithSkiInCart && !_.isEmpty(app.data.GuestsWithSkiInCart)){  
                                    var customerobjectWithNewId = {}
                                    _.each(app.data.GuestsWithSkiInCart,function(folio,customerId){
                                        customerobjectWithNewId[app.data.CustomerId] = folio
                                        app.datal('GuestsWithSkiInCart',customerobjectWithNewId)
                                    })

                                 }
                                //-END-
                                 //part of partial pms payment
        
                                 if( app.data.loginNextURL && ((window.location.href.indexOf('summary/eReg')> -1) || (window.location.href.indexOf('partial-payment') > -1) || urlParameter && urlParameter== "partial-payment")) {
                                    app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                    return;
                                }
                                else if (r_l.ResetPwd == 'Y') {
                                    app.data.messages.push({
                                        type: 'alert', 'class': 'alert-error', actions: [],
                                        title: app.localization.general.login.err.newPasswordRequired
                                    });
                                    app.dispatcher.dispatch.apply(app.dispatcher, ['profile', 'change', [eventName, password, r_us.ConflictingSpaBookingRemoved == 'Y']])
                                } else {
                                    if (r_us && r_us.ConflictingSpaBookingRemoved == 'Y') {
                                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                            title:app.localization.general.conflictingSpaBookingRemovedTitle,
                                            message:app.localization.general.conflictingSpaBookingRemoved
                                        });
                                        app.dispatcher.replace('summary');
                                        return
                                    }
                                    if (eventName || oAuthLogin) {
                                        if(oAuthLogin && app.customization.renderVueLoginApp){
                                            app.views.userView.event.fire('renderLoginVue', ['splash']);
                                        } else if(eventName === 'renderLoginVue' && app.customization.renderVueLoginApp) {
                                            app.views.userView.event.fire(eventName, ['splash']);
                                        } else if(oAuthLogin){
                                            //if package,
                                            var isVueSpaPackageRoute = app.dispatcher && app.dispatcher.currentRoute && _.some(app.dispatcher.currentRoute, function(subRoute){
                                                return subRoute === 'package';
                                            });

                                            if(isVueSpaPackageRoute && app.data.vueAppRef) {
                                                    app.commonViewHelper.loginUserIfVuePackage(app.data.vueAppRef, oAuthLogin, r_us)
                                            } else{
                                                app.dispatcher.hashChangeHandler('', app);
                                            }
                                        } else {
                                            app.views.userView.event.fire(eventName, [true]);
                                        }
                                        return
                                    }
                                    if (app.data.loginNextURL) {
                                        app.dispatcher.redirect.apply(app.dispatcher, app.data.loginNextURL);
                                        app.data.loginNextURL = undefined;
                                    } else {
                                        app.dispatcher.replace('summary');
                                    }
                                }
                               
                            })
                            .fail(function (r_us, r_fb) {
                                window.location.reload(false);
                                $('#progressIndicator').modal('hide');  
                            })
                    })
                    .fail(function (r_l) {
                        // if (eventName) {
                        //     app.views.userView.event.fire(eventName, [false]);
                        //     return
                        // }
                        if (!!email && !!password) {
                            app.data.messages.push({
                                type: 'alert', 'class': 'alert-error', actions: [],
                                title: app.localization.general.login.err.invalidCredentials
                            });
                        }
                        $('#progressIndicator').modal('hide');
                        if(mode !== 'signon'){
                            //redirect only when mode is not signon - you get this page after folio login for members
                            app.dispatcher.dispatch('profile', 'login', ['fail']);
                        } else {
                            app.dispatcher.dispatch('profile', 'signon', ['fail']);
                        }

                    })
            },

            userLogout: function (force, noRedirect) {
                   var deferreds = [],
                   golfBookingFolioset ={};
                $.when(app.models.systemModel.getData('folioBookings', {}))
                    .always(function (r_fb) {
                        app.data.redeemedGCs = app.data.redeemedGCs || {};
                        app.data.redeemedGCs[app.data.WebFolioId] = app.data.redeemedGCs[app.data.WebFolioId] || [];
                        _.each(app.data.redeemedGCs[app.data.WebFolioId], function (v, k, l) {
                            if (v.GiftCertId) {
                                var semaphore_rgc = $.Deferred();
                                deferreds.push(semaphore_rgc);
                                app.controllers.cartController.refundGC(v.GiftCertId, true)
                                    .always(function () {
                                        semaphore_rgc.resolve();
                                    });
                            }
                        })
                        _.each(r_fb.WebFolioItem, function (v, k, l) {
                            var semaphore_ri = $.Deferred();
                            if (v.Category == "Golf" && !golfBookingFolioset[v.FolioId] || v.Category != "Golf") { // each golfCancel call removes an entire golf booking. Should only run once per folioId
                                deferreds.push(semaphore_ri);
                                app.controllers.cartController.removeItem(v.Category, v.FolioId, v.FolioItemId, true, '', '', v.BookingId)
                                    .always(function () {
                                        semaphore_ri.resolve();
                                    });
                            }
                            v.Category == "Golf" ? golfBookingFolioset[v.FolioId] = true : ''
                        })

                        $.when.apply(this, deferreds).always(function () {
                            var store = null;
                            app.data.CustomerId = null;
                            if (app.data.vueAppRef) store = app.data.vueAppRef.$store;
                            else if (app.data.modeSelectorVueAppRef) store = app.data.modeSelectorVueAppRef.$store;
                            else if (app.data.optionalClassVueAppRef) store = app.data.optionalClassVueAppRef.$store;
                            else if(app.data.vueLoginAppRef) {
                                if(!store){
                                    store = app.data.vueLoginAppRef.$store
                                } else {
                                    store = _.extend(store, app.data.vueLoginAppRef.$store)
                                    store.commit('setFirstName',{firstName: r_l.FirstName}); //if you previously selected a service, before logging in, then upon return to that page again, it 
                                }
                            }
                            else if (app.data.eRegVueAppRef) store = app.data.eRegVueAppRef.$store;
                            if (store) store.commit('setStore');
                            if (app.data.eRegVueAppRef) app.data.eRegVueAppRef.$destroy();
                            if (app.data.vueAppRef) app.data.vueAppRef.$destroy();
                            if (app.data.modeSelectorVueAppRef) app.data.modeSelectorVueAppRef.$destroy();
                            if (app.data.optionalClassVueAppRef) app.data.optionalClassVueAppRef.$destroy();
                            if (app.data.vueLoginAppRef) app.data.vueLoginAppRef.$destroy();
                            app.models.spaModel.resetTTL('spaAvailabilityV2');
                            app.models.spaModel.resetTTL('spaAvailability');

                            app.data = {};
                            app.dataclear();
                            app.datal('spaClassQueue', {});
                            app.datal('datePickedCustomerList', {});
                            app.datal('user_equipment_not_loggedin', {});
                            app.datal('thirdPartyAuth', false);
                            app.datal('GuestsWithSkiInCart',{})

                            app.models.systemModel.monitorSystemStateDfd && app.models.systemModel.monitorSystemStateDfd.reject({});
                            delete app.controllers.initController.InitializedDfd
                            app.controllers.initController.init();
                            app.controllers.initController.InitializedPromise.then(function () {
                                if (noRedirect) return;
                                if (force != 'silent') {
                                    force = force || '';
                                    app.dispatcher.redirect('summary', '', [force]);
                                } else {
                                    app.dispatcher.redirect('greeting', '');
                                }
                            })
                      
                        })
                    })

            },

            removeGroupMember: function(groupCustomerId) {
                
                app.models.userModel.getData('removeGroupMember', {
                    CustomerId: app.data.CustomerId,
                    CustomerGUID: app.data.CustomerGUID,
					GroupCustomerId: groupCustomerId
                }).then(function(){
                    app.dispatcher.redirect('profile','',[],true);
                }).fail(function(){
                    app.dispatcher.redirect('profile');
                    app.data.messages.push({
                        type: 'alert', 'class': 'alert-error', actions: [],
                        title: app.localization.general.err.defaultErr,
                        message: ""
                    });
                })
            },

        })
    });

